// Profiling instrumentation (--noplanmemo); only the mobile app arms it, so a normal build keeps the memo on.
let planMemoDisabled = false;

export const setPlanMemoDisabled = (disabled: boolean): void => {
  planMemoDisabled = disabled;
};

export const isPlanMemoDisabled = (): boolean => planMemoDisabled;
